import { useCallback, useEffect, useRef, useState } from "react";

/** Jak dlugo przycisk mowi "Skopiowano", zanim wroci do "Kopiuj". Wzorzec z components/developer/LogiWidok.tsx. */
export const CZAS_POTWIERDZENIA_KOPII_MS = 2000;

/**
 * Kopiowanie do schowka z potwierdzeniem na przycisku. `skopiowano` to klucz ostatnio skopiowanej rzeczy (np. id
 * linku) albo null, wiec jedna lista z wieloma przyciskami zmienia napis tylko na tym, ktory kliknieto.
 *
 * `kopiuj` zwraca false, gdy schowek jest niedostepny (HTTP, brak uprawnien): wywolujacy decyduje, co powiedziec
 * uzytkownikowi. Cichy catch z LogiWidok zostawialby tu klikniecie bez zadnego sladu, a link jest wlasnie po to, zeby go
 * komus przekazac.
 */
export function useKopiowanie(): {
  skopiowano: string | null;
  kopiuj: (klucz: string, tekst: string) => Promise<boolean>;
} {
  const [skopiowano, setSkopiowano] = useState<string | null>(null);
  const zegarRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (zegarRef.current) clearTimeout(zegarRef.current);
    },
    [],
  );

  const kopiuj = useCallback(async (klucz: string, tekst: string): Promise<boolean> => {
    try {
      await navigator.clipboard.writeText(tekst);
    } catch {
      return false;
    }
    setSkopiowano(klucz);
    if (zegarRef.current) clearTimeout(zegarRef.current);
    zegarRef.current = setTimeout(() => setSkopiowano(null), CZAS_POTWIERDZENIA_KOPII_MS);
    return true;
  }, []);

  return { skopiowano, kopiuj };
}
